// Constants
import {
  SCROLL_TOP_ACTION_PROPS,
  SCROLL_TOP_DEBOUNCE_TIMER,
} from './constants/scroll-top.constants';
// Types
import { ScrollTopMethodsHandlersType } from './types/scroll-top.handlers.type';

const scrollToTopInEveryViewEventHandler = (): void => {
  setTimeout(() => {
    window.scrollTo(SCROLL_TOP_ACTION_PROPS);
  }, SCROLL_TOP_DEBOUNCE_TIMER);
};

const ScrollTopHandlers = (): ScrollTopMethodsHandlersType => ({
  handleScrollToTopInEveryViewEvent: () => scrollToTopInEveryViewEventHandler(),
});

export { ScrollTopHandlers };
